import { render, staticRenderFns } from "./ServiceAccountsPage.vue?vue&type=template&id=65b21cd0&scoped=true"
import script from "./ServiceAccountsPage.vue?vue&type=script&lang=ts"
export * from "./ServiceAccountsPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b21cd0",
  null
  
)

export default component.exports